module.exports = __webpack_public_path__ + "static/media/fire-invoice.b8d45ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/fire-invoice.png
// module id = 1791
// module chunks = 0